import React from 'react'
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
    Button
} from "@material-ui/core/";
import IntlMessages from 'util/IntlMessages';

const ConfirmDialog = (props) => {
        return (
            <Dialog
                className="custom-popup confirm-popup"
                PaperProps={{ classes: { root: 'custom-popup-root' } }}
                open={true}
                onClose={props.onCancel}
                disableBackdropClick={true}
            >
                <div className="popup-wrap">
                    <div className="popup-header">
                        <DialogTitle className="popup-title"><IntlMessages id="logout.alert"></IntlMessages></DialogTitle>
                    </div>
                    <DialogContent className="popup-content">
                        {
                            props.confirm_dialog_type === 'delete-custom' ?
                                <div>{`Do you want to delete all (${props.custom_count}) manual annotations for the current night?`}</div>
                            : props.confirm_dialog_type === 'delete-system' ?
                                <div>{`Do you want to delete all (${props.system_count}) system annotations for the current night?`}</div>
                            : props.confirm_dialog_type === 'delete-desaturation' ?
                                <div>{`Do you want to delete all (${props.desaturation_count}) system desaturations for the current night?`}</div>
                            : props.confirm_dialog_type === 'delete-multiple' ?
                                <div>{`Do you want to delete all (${props.multiple_count}) selected annotations for the current night?`}</div>
                            : null
                        }
                    </DialogContent>
                    <DialogActions className="popup-footer">
                        <Button 
                            onClick={props.onCancel}
                            className="secondary-button"
                            disableRipple={false}
                            disableFocusRipple={false}
                        >
                            <IntlMessages id="main.cancel"></IntlMessages>
                        </Button>
                        <Button 
                            onClick={props.onConfirm}
                            className="primary-button"
                            disableRipple={false}
                            disableFocusRipple={false}
                        >
                            <IntlMessages id="button.delete"></IntlMessages>
                        </Button>
                    </DialogActions>
                </div>
            </Dialog>
        )
}

ConfirmDialog.propTypes = {
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    custom_count: PropTypes.number,
    system_count: PropTypes.number,
    desaturation_count: PropTypes.number,
    confirm_dialog_type: PropTypes.string
}

export default ConfirmDialog;